export class TZQuestion
{
    constructor() {
        this.systemId="";
        this.seq=0;
        this.group1="";
        this.group2="";
        this.question="";
        this.questionDesc="";
        this.answerType="";

    }

    // /** @var TZAnswer[] $Answers */
    // public $Answers=[];
    //
    // public bool $isUserAnswered=false;
    // userAnswerText="";
}

export class TZAnswer
{
    constructor() {
        this.systemId="";
        this.relQuestion="";
        this.seq=0;
        this.answer="";
        this.answerDesc="";
        this.score="";
        this.tags="";
        this.actionForPatient="";
        this.actionForCaseMag="";
        this.actionForMemo="";
        this.userSelected=false;
    }

}
